// extracted by mini-css-extract-plugin
export default {"wrapper":"Seperator_wrapper__58fXO","seperator":"Seperator_seperator__3tSt4"};